/**
 * /fleet/new — alta de vehículo.
 *
 * Usa el mismo VehicleForm que /fleet/:id/edit: antes esta pantalla tenía siete
 * campos propios y la ficha mostraba trece, así que la mitad de los datos solo
 * podían entrar por importación.
 */
import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Link, useNavigate } from '@tanstack/react-router'
import { ApiError, createVehicle } from '@/lib/api'
import { PageHeader } from '@/components/app-shell'
import { Card, CardBody } from '@/components/ui/card'
import { VehicleForm, type VehicleFormValues } from '@/components/vehicle-form'

export function FleetNewPage() {
  const navigate = useNavigate()
  const qc = useQueryClient()
  const [error, setError] = useState<string | null>(null)
  const [fields, setFields] = useState<Record<string, string>>({})

  const mutation = useMutation({
    mutationFn: (values: VehicleFormValues) => createVehicle(values),
    onSuccess: async (res) => {
      await qc.invalidateQueries({ queryKey: ['vehicles'] })
      void navigate({ to: '/fleet/$vehicleId', params: { vehicleId: res.vehicle.id } })
    },
    onError: (err) => {
      if (err instanceof ApiError) {
        setError(err.message)
        setFields(err.fields ?? {})
      } else setError('No se pudo crear.')
    },
  })

  return (
    <>
      <PageHeader
        title="Add vehicle"
        actions={
          <Link to="/fleet" className="text-sm text-muted-foreground hover:text-foreground">
            Cancelar
          </Link>
        }
      />
      <Card className="mx-auto max-w-xl">
        <CardBody>
          <VehicleForm
            submitLabel="Guardar"
            pending={mutation.isPending}
            error={error}
            fieldErrors={fields}
            onSubmit={(values) => {
              setError(null)
              setFields({})
              mutation.mutate(values)
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}
